import { DesignData } from 'src/store/design/types';
import getUsedSpreads from './getUsedSpreads';

/**
 * Calculates the correct product_uid based on which spreads have content
 * For apparel products with variants, this ensures we select the right variant
 * based on which print areas are actually being used
 *
 * @param designData - The current design structure
 * @returns The correct product_uid, or the current one if no better match is found
 */
const calculateCorrectProductUid = (designData?: DesignData): string | undefined => {
  if (!designData?.variants?.length) {
    return designData?.product_uid;
  }

  // Get spread names that have actual content
  const usedSpreadNames = getUsedSpreads(designData);

  if (!usedSpreadNames.size) {
    // No content yet, return the current product_uid
    return designData.product_uid;
  }

  // Find the smallest variant that contains all used spread names
  const usedSpreadNamesArray = Array.from(usedSpreadNames);
  const matchingVariants = designData.variants.filter((variant) => usedSpreadNamesArray.every((spreadName) => variant.types.includes(spreadName)));

  if (!matchingVariants.length) {
    // No matching variant found, return current product_uid
    return designData.product_uid;
  }

  return matchingVariants[0].product_uid;
};

export default calculateCorrectProductUid;
